import { createFileRoute, Outlet } from '@tanstack/react-router';

import { InsightsLayout } from '@/features/insights/insights-layout';

export const Route = createFileRoute('/_app/projects/$projectId/insights')({
  component: SectionLayout,
});

function SectionLayout() {
  const { projectId } = Route.useParams();
  return (
    <InsightsLayout projectId={projectId}>
      <Outlet />
    </InsightsLayout>
  );
}
